import React from 'react';
import TypeGroupSection from './TypeGroupSection';

const windowFrameMaterialOptions = [
  'Aluminum',
  'Aluminum Clad Wood',
  'Fiberglass',
  'Unplasticized Polyvinyl Chloride (uPVC)',
  'Vinyl',
  'Wood',
  'Other',
];

const windowConfig = {
  gatingField: 'number_of_window_types',
  maxCount: 3,
  fields: [
    { kind: 'text', nameTemplate: 'window_product_name_{n}', label: 'Window Product Name' },
    { kind: 'text', nameTemplate: 'window_manufacturer_{n}', label: 'Window Manufacturer' },
    { kind: 'decimal', nameTemplate: 'whole_window_u_value_{n}', label: 'Whole Window U-Value', unit: 'BTU/hr⋅ft²⋅°F' },
    {
      kind: 'select',
      nameTemplate: 'window_frame_material_{n}',
      label: 'Window Frame Material',
      options: windowFrameMaterialOptions,
      emptyOption: true,
    },
    { kind: 'decimal', nameTemplate: 'window_glazing_SHGC_{n}', label: 'Glazing SHGC' },
  ],
};

// Door option list has a genuinely different uPVC label/value than Window's ("uPVC
// (Unplasticized Polyvinyl Chloride)" vs. Window's "Unplasticized Polyvinyl Chloride (uPVC)") —
// confirmed by direct comparison, not assumed identical. Kept as a separate constant, not shared.
const doorFrameMaterialOptions = [
  'Aluminum',
  'Aluminum Clad Wood',
  'Fiberglass',
  'uPVC (Unplasticized Polyvinyl Chloride)',
  'Vinyl',
  'Wood',
  'Other',
];

// Doors are single-instance and ungated (gatingField: null, maxCount: 1) — nameTemplate has no
// '{n}' placeholder for door fields since the source never suffixes them with an index.
const doorConfig = {
  gatingField: null,
  maxCount: 1,
  fields: [
    { kind: 'text', nameTemplate: 'door_manufacturer', label: 'Door Manufacturer' },
    { kind: 'text', nameTemplate: 'door_product_name', label: 'Door Product Name' },
    { kind: 'decimal', nameTemplate: 'whole_door_u_value', label: 'Whole Door U-Value', unit: 'BTU/hr⋅ft²⋅°F' },
    {
      kind: 'select',
      nameTemplate: 'door_frame_material',
      label: 'Door Frame Material',
      options: doorFrameMaterialOptions,
      emptyOption: true,
    },
  ],
};

export default function WindowDoorTab({ project, editable, handleInputChange, handleFieldValidityChange }) {
  const ctx = { project, editable, handleInputChange, handleFieldValidityChange };
  return (
    <table className='project-detail-table'>
      <tbody>
        <tr>
          <td>Number of Window Types</td>
          <td>
            {editable === true ? (
              <select
                name='number_of_window_types'
                onChange={handleInputChange}
                className='edit-input'
                defaultValue={project.number_of_window_types}
              >
                <option value=''></option>
                <option value='1'>1</option>
                <option value='2'>2</option>
                <option value='3'>3</option>
              </select>
            ) : (
              project.number_of_window_types
            )}
          </td>
        </tr>
        <TypeGroupSection {...windowConfig} {...ctx} />
        <TypeGroupSection {...doorConfig} {...ctx} />
      </tbody>
    </table>
  );
}
